import Request from "../../shared/utils/_request";

class Dashboard {
  constructor() { }
  /**
   * 待办事项
   */
  pendingData() {
    return Request.post("/home/getPendingData");
  }
  /**
   * 团队数据
   * @param {{created_start, created_end}} payload
   */
  teamData(payload) {
    return Request.post("/home/getTeamData", payload);
  }
  /**
   * 数据看板
   * @param {{created_start, created_end}} payload
   */
  dataView(payload) {
    return Request.post("/home/getDataOverview", payload);
  }
  /**
   * 职位新增数据
   * @param {{created_start, created_end}} payload
   */
  jobNew(payload) {
    return Request.post("/home/getJobNewCount", payload);
  }

  /**
   * 订单新增数据
   * @param {{created_start, created_end}} payload
   */
  orderNew(payload) {
    return Request.post("/home/getPostNewCount", payload);
  }

}

export const dashboard = new Dashboard();
